import React from "react";
import { useSubscriptionCompetitionsPrizesPageContext } from "../context";

type NrOfTicketsProps = {
  compId: number;
};

const NrOfTickets = ({ compId }: NrOfTicketsProps) => {
  const { lobbyContent } = useSubscriptionCompetitionsPrizesPageContext();
  const youveEnteredEntry = lobbyContent.youveEntered.find(item => Number(item.compid) === compId);
  if (!youveEnteredEntry) {
    return null;
  }
  return (
    <div className={"flex max-lg:items-center gap-1 lg:flex-col text-[#308835] lg:min-w-[60px]"}>
      <div className={"font-normal text-xs leading-4 lg:text-[13px]"}>You have</div>
      <div className={""}>
        <span className={"text-[#308835] max-lg:text-center text-xs lg:text-sm leading-4"}>
          <strong className={""}>
            {youveEnteredEntry.nrOfTickets} {youveEnteredEntry.nrOfTickets === 1 ? "ticket" : "tickets"}
          </strong>
        </span>
      </div>
    </div>
  );
};

export default NrOfTickets;
